import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimesService {

  constructor(private http: HttpClient) { }

  getgradesGroupedByDismissal() {
    return this.http.get(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/dismissal-times`)
}

updategradesGroupedByDismissal(body, confirmed: boolean = false) {
  const url = environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/dismissal-times?confirmed=${confirmed}`;
  return this.http.post(url, body)
}

getSchoolTimes() {
  return this.http.get(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/school-times`)
}

}
